import { useMutation, useQueryClient } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

interface UpdateEmailToggleParams {
  id: string;
  disable: boolean;
}

export const updateEmailToggleAPI = async (params: UpdateEmailToggleParams) => {
  const { id, disable } = params;
  const response = await baseAPI.patch<unknown>(
    `/email/toggles/${id}/${disable ? 'disable' : 'enable'}`,
  );
  return response.data;
};

export const useUpdateEmailToggle = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateEmailToggleAPI,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [KEYS.EMAIL_TOGGLES] });
    },
  });
};
